import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonServiceService {
  constructor() { }

  formatDate(date: any) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  parseNumberOrNull(val: any) {
    if (val === null || val === undefined || val === '') return null;
    if (val === 0 || val ==='0') return 0
    const parsed = Number(val);
    return Number.isNaN(parsed) ? null : parsed;
  }

  parseNumberOrZero(val: any) {
    if (val === null || val === undefined || val === '') return 0;
    if (val === 0 || val === '0') return 0
    const parsed = Number(val);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
}
